import { Grid, Navigation } from "../swiper/swiperConfig";

const gdzSliderClass = "gdz-slider";
const popularRecommendSliderClass = "colored-list";

const configGdzSliderBySubject = {
  speed: 800,
  direction: "horizontal",
  allowTouchMove: false,
  watchSlidesProgress: true,
  slideVisibleClass: "article-content__gdz-block-visible",
  slideClass: "gdz-slide",
  modules: [Navigation],
  breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 24,
    },
    800: {
      slidesPerView: 2,
      spaceBetween: 24,
    },
    1290: {
      slidesPerView: 3,
      spaceBetween: 24,
    },
  },
};

// todo: удалить этот конфиг после того как появится группа гдз на главной
const configGdzSliderWithoutSubject = {
  speed: 800,
  direction: "horizontal",
  allowTouchMove: false,
  watchSlidesProgress: true,
  slideVisibleClass: "article-content__gdz-block-visible",
  slideClass: "gdz-slide",
  modules: [Grid, Navigation],
  observer: true,
  observeParents: true,
  breakpoints: {
    320: {
      slidesPerView: 1,
      grid: {
        rows: 2,
        fill: "row",
      },
    },
    900: {
      slidesPerView: 2,
      grid: {
        rows: 2,
        fill: "row",
      },
    },
    1146: {
      slidesPerView: 3,
      grid: {
        rows: 2,
        fill: "row",
      },
    },
  },
  on: {
    init() {
      this.el?.classList.add("grid-gdz");
    },
  },
};

const configPopularRecommendSlider = {
  allowTouchMove: false,
  direction: "horizontal",
  speed: 800,
  spaceBetween: 16,
  observer: true,
  observeParents: true,
  breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 24,
    },
    800: {
      slidesPerView: 2.5,
      slidesOffsetBefore: 38,
      slidesOffsetAfter: 38,
    },
    1000: {
      slidesPerView: 2.84,
      slidesOffsetBefore: 38,
      slidesOffsetAfter: 38,
    },
    1050: {
      slidesPerView: 3.5,
      slidesOffsetBefore: 38,
      slidesOffsetAfter: 38,
    },
    1280: {
      slidesPerView: 4.5,
      slidesOffsetBefore: 38,
      slidesOffsetAfter: 38,
    },
    1440: {
      slidesPerView: 4.5,
      slidesOffsetAfter: 58,
      slidesOffsetBefore: 58,
    },
  },
  on: {
    afterInit() {
      const parent = this.el?.parentNode;
      const parentClasses = parent?.classList || [];

      const isPopularOrRecommend =
        parentClasses.contains("recommended") ||
        parentClasses.contains("popular");
      const hasFewSlides = this.slides.length <= 6;

      if (hasFewSlides && isPopularOrRecommend) {
        this.params.loop = false;
        this.params.slidesOffsetBefore = -180;
        this.params.slidesOffsetAfter = 140;
        this.el.classList.add(`slide-${this.slides.length}`);
        this.navigation.prevEl.classList.add("swiper-button-disabled");
      }
    },
  },
};

export {
  configGdzSliderBySubject,
  configGdzSliderWithoutSubject,
  configPopularRecommendSlider,
  gdzSliderClass,
  popularRecommendSliderClass,
};
